import { ISVG } from "./UrlIcon";

export interface ICopyIconProps extends ISVG {}

export const CopyIcon = ({ width, height, fill }: ICopyIconProps) => {
    const _width = width ?? 18;
    const _height = height ?? 20;
    const _fill = fill ?? "white";

    return (
        <svg width={_width} height={_height} viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M15.2077 15.6996C15.2099 15.6996 15.2121 15.6995 15.2143 15.6994C16.3692 15.6956 17.3074 14.7551 17.3074 13.5994V4.63371C17.3074 4.60719 17.2969 4.58175 17.2781 4.563L13.0438 0.328703C13.0251 0.30995 12.9996 0.299414 12.9731 0.299414H7.60738C6.44938 0.299414 5.50742 1.24138 5.50742 2.39937V2.79942C5.50742 3.0755 5.73139 3.29947 6.00747 3.29947C6.28355 3.29947 6.50752 3.0755 6.50752 2.79942V2.39937C6.50752 1.79285 7.001 1.29937 7.60752 1.29937H12.6003L16.3077 5.00674V13.5995C16.3077 14.206 15.8142 14.6995 15.2077 14.6995H14.2076C13.9315 14.6995 13.7076 14.9235 13.7076 15.1996C13.7076 15.4756 13.9315 15.6996 14.2076 15.6996H15.2077Z"
                fill={_fill}
                stroke={_fill}
                strokeWidth="0.2"
                strokeLinejoin="round"
            />
            <path
                d="M17.3064 4.79957V4.79951C17.3064 4.52343 17.0824 4.29946 16.8063 4.29946H14.4063C13.7998 4.29946 13.3063 3.80598 13.3063 3.19946V0.79946C13.3063 0.523383 13.0824 0.299414 12.8063 0.299414C12.5302 0.299414 12.3062 0.523383 12.3062 0.79946V3.19946C12.3062 4.35745 13.2482 5.29941 14.4062 5.29941H16.8062C17.0823 5.29941 17.3062 5.07547 17.3064 4.79957Z"
                fill={_fill}
                stroke={_fill}
                strokeWidth="0.2"
                strokeLinejoin="round"
            />
            <path
                d="M10.4065 19.6994C10.4078 19.6994 10.4091 19.6994 10.4104 19.6994C11.5667 19.6973 12.5066 18.7561 12.5066 17.5994V8.6337C12.5066 8.60718 12.4961 8.58174 12.4773 8.56299L8.24302 4.3287C8.22426 4.30995 8.19883 4.29941 8.17231 4.29941H2.80659C1.6486 4.29941 0.706641 5.24137 0.706641 6.39937L0.706775 17.5995C0.706775 18.7575 1.64873 19.6994 2.80673 19.6994H10.4065ZM1.70673 6.39944C1.70673 5.79292 2.20021 5.29944 2.80673 5.29944H7.79934L11.5067 9.0068L11.5068 17.5996C11.5068 18.2061 11.0134 18.6996 10.4068 18.6996H2.80673C2.20021 18.6996 1.70673 18.2061 1.70673 17.5996V6.39944Z"
                fill={_fill}
                stroke={_fill}
                strokeWidth="0.2"
                strokeLinejoin="round"
            />
            <path
                d="M12.5076 8.79955V8.79949C12.5076 8.52342 12.2836 8.29945 12.0075 8.29945H9.60751C9.00099 8.29945 8.50751 7.80597 8.50751 7.19945V4.79946C8.50751 4.52338 8.28354 4.29941 8.00747 4.29941C7.73139 4.29941 7.50742 4.52338 7.50742 4.79946V7.19959C7.50742 8.35758 8.44938 9.29954 9.60738 9.29954H12.0074C12.2835 9.29954 12.5074 9.07557 12.5076 8.79955Z"
                fill={_fill}
                stroke={_fill}
                strokeWidth="0.2"
                strokeLinejoin="round"
            />
        </svg>
    );
};
